import React, { useState, useEffect, useRef } from 'react';
import LoginLogo from '../../Assets/images/Frame 39059 1.png';
import LoginImg from '../../Assets/images/Loginimage-woman-smile-happy-joy 1.png';
import BackgroundImage from '../../Assets/images/LoginAndSignUpBG.png';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import { API_BASE_URL } from '../../config';
const OTP = ({ onSignUp }) => {
  const navigate = useNavigate();
  const [otp, setOtp] = useState(['', '', '', '']);
  const inputRefs = useRef([]);
  const [errors, setErrors] = useState({});
  const [timer, setTimer] = useState(120); // 2 minutes countdown
  const [canResend, setCanResend] = useState(false);

  // const location = useLocation();
  // const { phoneNumber } = location.state || {};
   const phoneNumber = sessionStorage.getItem('phoneNumber') || '';
  
  // console.log(phoneNumber);

  const handleLoginClick = () => navigate('/login');
  const handleSignUpClick = () => navigate('/signup');

  const validateForm = () => {
    const newErrors = {};
    if (otp.some(value => value === ''))
      newErrors.otp = 'Please provide a 4-digit OTP';
    return newErrors;
  };

  const handleChange = (e, index) => {
    const value = e.target.value;
    if (/^[0-9]$/.test(value) || value === '') {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (value !== '' && index < 3) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Enter') handleOTP();
    if (e.key === 'Backspace' && otp[index] === '' && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handleOTP = async () => {
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length === 0) {
      const otpValue = otp.join('');
      const requestBody = { otp: otpValue };

      try {
        const response = await axios.post(
          `${API_BASE_URL}/account/verify-otp/`,
          // 'https://finwise-backend.vercel.app/account/verify-otp/',
          // 'https://finwiseback.finwise.com.bd/account/verify-otp/',
          // 'http://127.0.0.1:8000/account/verify-otp/',
          requestBody,
          {
            headers: {
              'Content-Type': 'application/json',
              'X-CSRFToken': 'z91BDRm6OBq66qusVK8HCtvtdW686hFC',
            },
            withCredentials: true,
          }
        );

        if (response.data) {
          Swal.fire({
            // icon: 'success',
            title: 'OTP Verified',
            text: 'Your OTP has been verified successfully!',
            confirmButtonText: 'Okay',
            customClass: {
              popup: 'w-72 h-auto p-3',
              title: 'text-lg',
              content: 'text-xs',
              confirmButton:
                'bg-headerBtn text-white px-4 py-1 text-sm rounded-md',
            },
          }).then(() => {
            onSignUp();
            navigate('/dashboard');
          });
        } else {
          Swal.fire({
            // icon: 'error',
            title: 'Verification Failed',
            text: 'OTP verification is failed. Please try again.',
            confirmButtonText: 'Retry',
            customClass: {
              popup: 'w-72 h-auto p-3',
              title: 'text-lg',
              content: 'text-xs',
              confirmButton:
                'bg-headerBtn text-white px-4 py-1 text-sm rounded-md',
            },
          });
          setErrors({ otp: 'OTP verification failed. Please try again.' });
        }
      } catch (error) {
        Swal.fire({
          // icon: 'error',
          title: 'Verification Error',
          text: 'Please try after 30 minutes.',
          confirmButtonText: 'Okay',
          customClass: {
            popup: 'w-72 h-auto p-3',
            title: 'text-lg',
            content: 'text-xs',
            confirmButton:
              'bg-headerBtn text-white px-4 py-1 text-sm rounded-md',
          },
        });
        setErrors({ otp: 'OTP verification failed. Please try again later.' });
      }
    } else {
      setErrors(validationErrors);
    }
  };

  const handleResendOTP = async () => {
    setTimer(120); // Reset timer to 2 minutes
    setCanResend(false); // Disable resend button

    try {
      const response = await axios.post(
        `${API_BASE_URL}/account/resend-otp/`,
        // 'https://finwise-backend.vercel.app/account/resend-otp/',
        // 'https://finwiseback.finwise.com.bd/account/resend-otp/',
        // 'http://127.0.0.1:8000/account/resend-otp/',
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            Cookie:
              'csrftoken=YmXTCIwY0VzFyPEcOP15TL1stJiuNrZF; sessionid=l2509fh2uv9ulyzd6412afq0ufd2elpr',
          },
          withCredentials: true,
        }
      );

      if (response.status === 200) {
        Swal.fire({
          // icon: 'success',
          title: 'OTP Resent',
          text: 'A new OTP has been sent to your registered mobile number.',
          confirmButtonText: 'Okay',
          customClass: {
            popup: 'w-72 h-auto p-3',
            title: 'text-lg',
            content: 'text-xs',
            confirmButton:
              'bg-headerBtn text-white px-4 py-1 text-sm rounded-md',
          },
        });
      } else {
        throw new Error('Failed to resend OTP');
      }
    } catch (error) {
      Swal.fire({
        // icon: 'error',
        title: 'Resend Failed',
        text: 'An error occurred while resending OTP. Please try again.',
        confirmButtonText: 'Retry',
        customClass: {
          popup: 'w-72 h-auto p-3',
          title: 'text-lg',
          content: 'text-xs',
          confirmButton: 'bg-headerBtn text-white px-4 py-1 text-sm rounded-md',
        },
      });
      console.error('Error resending OTP:', error);
    }
  };

  useEffect(() => {
    if (timer > 0) {
      const countdown = setInterval(() => {
        setTimer(prev => prev - 1);
      }, 1000);
      return () => clearInterval(countdown);
    } else {
      setCanResend(true); // Allow resend after countdown
    }
  }, [timer]);

  useEffect(() => {
    if (canResend) {
      // Optionally show a message or change the button text to indicate the user can resend OTP
    }
  }, [canResend]);

  return (
    <div
      className="flex items-center justify-center min-h-screen md:py-0 py-2 p mt-20"
      style={{ backgroundImage: `url(${BackgroundImage})` }}
    >
      <div className="bg-white md:p-4 p-8 lg:pl-10 lg:pr-10 gap-10 shadow-xl rounded-xl">
        {/* top secton */}
        <div className="items-center justify-center flex">
          <img
            src={LoginLogo}
            alt="LoginLogo"
            className="md:h-16 h-10 lg:h-16 mb-0 pr-10 lg:mb-1"
          />
        </div>
        <h2 className="items-center justify-center flex lg:font-bold lg:mb-5 text-xs lg:text-sm">
          Trade and Finance Solutions
        </h2>
        <div className="items-center justify-center flex flex-col lg:flex-row gap-16">
          {/* left section */}
          <div className="lg:block hidden">
            <img
              src={LoginImg}
              alt="LoginImg"
              className="md:h-40 h-32 lg:h-44"
            />
          </div>

          {/* right section */}
          <div className="">
            <h2 className="text-xl text-center lg:text-2xl mt-1 mb-2 heading">
              Registration
            </h2>
            <p className="flex justify-center mb-2">Otp Verification</p>
            <p className="mb-0 text-center text-xs text-gray-600">
              Do You want to change Number: {''}
              <span className="font-bold">{phoneNumber}</span>
              <button onClick={handleSignUpClick} className="underline ml-2">
                Change
              </button>
            </p>
            <div className="w-full space-y-4 mt-2 text-xs">
              <div className="flex space-x-4 items-center justify-center mt-4">
                {otp.map((digit, index) => (
                  <input
                    key={index}
                    ref={el => (inputRefs.current[index] = el)}
                    type="text"
                    maxLength="1"
                    value={digit}
                    onChange={e => handleChange(e, index)}
                    onKeyDown={e => handleKeyDown(e, index)}
                    className="w-12 h-12 text-center text-2xl border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                ))}
              </div>
              {errors.otp && (
                <p className="text-red-500 text-xs text-left mb-0 -mt-2">
                  {errors.otp}
                </p>
              )}

              {/* Resend OTP Button */}
              <div className="text-right mt-4">
                <button
                  onClick={handleResendOTP}
                  className={`text-red-600  ${
                    canResend ? '' : 'opacity-50 cursor-not-allowed'
                  }`}
                  disabled={!canResend}
                >
                  {canResend
                    ? 'Resend OTP'
                    : `Resend OTP in ${Math.floor(timer / 60)}:${(
                        '0' +
                        (timer % 60)
                      ).slice(-2)}`}
                </button>
              </div>

              {/* Submit Button */}
              <button
                onClick={handleOTP}
                className="w-full bg-orange-300 text-white py-2 px-6 hover:bg-btnHover mb-2 font-bold rounded-2xl"
              >
                Submit
              </button>
              <p className="mb-0 text-center text-xs text-gray-600">
                Already have an account?
                <button onClick={handleLoginClick} className="underline ml-2">
                  Login
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OTP;
